<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';
import Integrations from '../../mixins/integrations';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [
    Integrations,
  ],

  data: () => ({
    config: {
      phone: '',
      enable: false,
    },

    integration: {
      id: null,
      name: 'whatsapp-mark',
    },
  }),

  methods :{
    load () {
      this.loading = true;

      this.$http.get(`/integration/config/${this.integration.name}`)
        .then((response) => {
          if (response.data.config) {
            this.config = response.data.config;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>

<template>
  <div
    class="bdk-wpp bdk-preflight"
  >
    <div
      class="d-flex flex-column bdk-max-w-screen-md bdk-mx-auto"
    >
      <div
        class="bdk-flex bdk-flex-col bdk-items-center"
      >
        <span
          v-text="__('Ative a integração de WhatsApp em suas Landing Pages')"
          class="bdk-text-xl bdk-font-medium bdk-text-gray-900 bdk-w-full"
        />

        <span
          v-html="__('A Integração do WhatsApp nas Landing Pages é uma ferramenta de contato prática para o seu lead contactar você.')"
          class="bdk-mt-4 bdk-text-base bdk-text-gray-500"
        />
      </div>

      <div
        class="bdk-w-full bdk-border-t bdk-border-gray-300 bdk-mx-auto bdk-my-6"
      />

      <div
        class="bdk-flex bdk-flex-col bdk-items-start"
      >
        <span
          v-text="__('Configuração')"
          class="bdk-text-xl bdk-font-medium bdk-text-gray-900 bdk-w-full"
        />

        <BaseInput
          label="Telefone"
          class="bdk-mt-4"
          v-model="config.phone"
          mask="(##) # ####-####"
          placeholder="(00) 0 0000-0000"
        />

        <BaseCheckbox
          class="bdk-mt-4"
          v-model="config.enable"
          :label="__('Exibir Integração em todas as Landing Pages')"
        />

        <button
          @click.prevent="save"
          class="bdk-inline-flex bdk-justify-center bdk-items-center bdk-px-6 bdk-py-3 bdk-border bdk-border-transparent bdk-rounded-md bdk-shadow-sm bdk-mt-4 bdk-bg-indigo-600 hover:bdk-bg-indigo-700"
        >
          <span
            v-text="__('Salvar')"
            class="bdk-text-base bdk-font-medium bdk-text-white"
          />
        </button>
      </div>
    </div>
  </div>
</template>
